export const toType = val => typeof val;

export const isUndefined = val => val === undefined;

export const isNull = val => val === null;

export const isEmptyString = val => val === '';

export const isUndefinedOrNull = val => isUndefined(val) || isNull(val);

export const isUndefinedOrNullOrEmpty = val =>
	isUndefinedOrNull(val) || isEmptyString(val);

export const isFunction = val => toType(val) === 'function';

export const isBoolean = val => toType(val) === 'boolean';

export const isString = val => toType(val) === 'string';

export const isNumber = val => toType(val) === 'number';

export const isArray = val => Array.isArray(val);

export const isObject = obj => obj !== null && typeof obj === 'object';
